import { motion } from "framer-motion";
import { useLang } from "@/context/LangContext";
import { Wallet, CreditCard, Percent, FileSignature, Star, Lock } from "lucide-react";

const HEADER_BG = "https://images.unsplash.com/photo-1709626011485-6fe000ea2dbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMDNkJTIwZ2VvbWV0cmljJTIwc2hhcGVzfGVufDB8fHx8MTc4Njg4OTAzMnww&ixlib=rb-4.1.0&q=85";

export default function AdvancedModules() {
  const { t } = useLang();
  const MODULES = [
    { icon: Wallet, title: t("modules.wallet"), items: t("modules.walletItems") },
    { icon: CreditCard, title: t("modules.payment"), items: t("modules.paymentItems") },
    { icon: Percent, title: t("modules.commission"), items: t("modules.commissionItems") },
    { icon: FileSignature, title: t("modules.contracts"), items: t("modules.contractsItems") },
    { icon: Star, title: t("modules.rating"), items: t("modules.ratingItems") },
  ];

  return (
    <div>
      <div className="relative border border-border overflow-hidden mb-10">
        <img src={HEADER_BG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-black/80" />
        <div className="relative z-10 p-8 sm:p-12">
          <div className="font-mono text-xs text-primary tracking-[0.3em] mb-2">{t("modules.tag")}</div>
          <h1 className="font-display font-extrabold text-3xl sm:text-4xl">{t("modules.title")}</h1>
          <p className="text-muted-foreground text-sm mt-3 max-w-xl">{t("modules.subtitle")}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {MODULES.map((m, idx) => (
          <motion.div key={idx} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: idx * 0.06 }}
            data-testid={`module-${idx}`} className="relative border border-border bg-[#0C0D14] p-6 opacity-70">
            <div className="absolute top-4 right-4 flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-wider text-[#FFD700] border border-[#FFD700]/40 px-2 py-1">
              <Lock className="w-3 h-3" /> {t("modules.disabled")}
            </div>
            <m.icon className="w-8 h-8 text-primary/60 mb-4" />
            <h3 className="font-display font-bold text-lg mb-3">{m.title}</h3>
            <ul className="space-y-1.5">
              {(m.items || []).map((it) => (
                <li key={it} className="font-mono text-xs text-muted-foreground flex items-center gap-2">
                  <span className="w-1 h-1 bg-primary/50" /> {it}
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
